<template>
	<div id="map">
		<div id="mapContainer">
			<iframe
				v-if="cookies.consent.googleMaps"
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.341100325653!2d20.4315935!3d44.8146152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6211bda3163175ff%3A0xa461c7bb28d347b5!2sENON%20Solutions!5e0!3m2!1sen!2srs!4v1786968104966!5m2!1sen!2srs"
				style="border: 0"
				allowfullscreen=""
				loading="lazy"
				referrerpolicy="strict-origin-when-cross-origin"
			></iframe>
			<div v-else class="map-consent">
				<!-- TODO: copy -->
				<button type="button" @click="cookies.enableConsent('googleMaps')">
					Enable Google Maps
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useCookies } from "@/assets/js/cookie";

const cookies = useCookies();
</script>

<style scoped>
#map {
	max-width: 100%;
	width: 100%;
	min-width: 360px;
	text-align: center;
	margin: 0 auto 5%;
	background-color: #ccc;
}

#mapContainer {
	position: relative;
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
}

#mapContainer iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.map-consent {
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;

	button {
		height: 49px;
		padding: 0 20px;
		border: 1px solid #53aa6c;
		border-radius: 8px;
		background: #53aa6c;
		color: #fff;
		font-weight: 600;
		cursor: pointer;
	}
}
</style>
